import { render, staticRenderFns } from "./Quadro.vue?vue&type=template&id=b4642484&"
import script from "./Quadro.vue?vue&type=script&lang=js&"
export * from "./Quadro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports